import { useEffect,useState } from "react";
import { Table,Form,Typography,Input,Button, message,Popconfirm } from "antd";
import {
    getFirestore,
    collection,
    getDocs,
    doc,
    setDoc,
    deleteDoc
} from "firebase/firestore";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";

import { validateName,validatePhone } from "./validations";
import {Create} from "./Create";

const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => {
  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{
            margin: 0,
          }}
          rules={[
            {
              required: true,
              message: `Debes ingresar ${title}!`,
            },
            {
                validator:dataIndex === "name" ? validateName : 
                dataIndex === "phone" ? validatePhone : "",
            }
          ]}
        >
          {<Input/>}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

export const Couriers = () => {

    // select form
    const [form] = Form.useForm();

    // states
    const [data,setData] = useState();
    const [editingKey,setEditingKey] = useState("");
    const [isModalOpen,setIsModalOpen] = useState(false);

    // access firebase
    const db = getFirestore();

    
    const mapCouriers = (res) => {
        return res.docs.map((ele) => ({
        key: ele.id,
        ...ele.data(),
        }));
    };

    // fetch couriers
    // eslint-disable-next-line
    const getCouriers = async () => {
        await getDocs(collection(db, "couriers")).then((res) => {
            setData(mapCouriers(res));
        })
    }
    
    useEffect(() => {
        if(!data){
            getCouriers();
        }
    },[data,getCouriers]);

    // set editable cell
    const isEditing = (record) => record.key === editingKey;

    // select editable cells
    const edit = (record) => {
        form.setFieldsValue({
            ...record,
        });
        setEditingKey(record.key);
    }

    // cancel edit
    const cancel = () => {
        setEditingKey("");
    }

    // save edit
    const save = async (key) => {
        try{
            const row = await form.validateFields();
            const newData = [...data];
            const index = newData.findIndex((item) => key === item.key);

            if(index >= 0){
                const item = newData[index];
                // insert element in data
                newData.splice(index,1,{
                    ...item,
                    ...row,
                });
                
                
                // Add a new document in collection "orders"
                setDoc(doc(db, "sizes", item.key), {
                    ...item,
                    ...row,
                });

                setData(newData);
                setEditingKey("");
            }
        }catch(error){
            console.log(error);
        }
    }

    // delete
    const handleDelete = async (key) => {
        await deleteDoc(doc(db, "couriers", key)).then(() => {
            message.success("courier deleted");
            getCouriers();
        }).catch((error) => {
            console.log(error);
        });
    } 

    // table columns
    const defaultCols = [
        {
            title:"Nombre",
            dataIndex:"name",
            key:"name",
            width:50,
            editable:true
        },
        {
            title:"Telefono",
            dataIndex:"phone",
            width:50,
            key:"phone",
            editable:true
        },
        {
            title:"Accion",
            dataIndex:"operation",
            width:100,
            render:(_,record) => {
                const editable = isEditing(record);
                return editable ? (
                    <span>
                        <Typography.Link
                        onClick={() => save(record.key)}
                        style={{
                            marginRight:8
                        }}
                        className="text-link"
                        >
                            Guardar
                        </Typography.Link>
                        <Typography.Link
                        onClick={() => cancel()}
                        style={{
                            marginRight: 8,
                        }}
                        className="text-link"
                        >
                        Cancelar
                        </Typography.Link>
                    </span>
                ) : (
                    <span>
                        <Typography.Link
                            disabled={editingKey !== ""}
                            onClick={() => edit(record)}
                            style={{
                                marginRight:8
                            }}
                            className="text-link"
                        >
                            <EditOutlined />
                        </Typography.Link>
                        <Popconfirm
                        title="Eliminar ?"
                        onConfirm={() => handleDelete(record.key)}
                        >
                            <Typography.Link
                            disabled={editingKey !== ""} className="text-link"
                            ><DeleteOutlined/></Typography.Link>
                        </Popconfirm>
                    </span>
                )
            }
        }
    ];

    // toggle editable cells    
    const columns = defaultCols.map((col) => {
        if (!col.editable) {
          return col;
        }
        return {
          ...col,
          onCell: (record) => ({
            record,
            inputType: "text",
            dataIndex: col.dataIndex,
            title: col.title,
            editing: isEditing(record),
          }),
        };
    });

    return(
        <div>
            <Button type="primary" onClick={() => setIsModalOpen(true)} size="large" style={{
          marginBottom: 16,
        }} className="btnOK" >Crear Courier</Button>
            <Form form={form} component={false}>
                {data === undefined || data.length === 0 ? (
                    <p>Cargando couriers....</p>
                ) : (
                    <Table
                    components={{
                        body: {
                        cell: EditableCell,
                        },
                    }}
                    bordered
                    dataSource={data}
                    columns={columns}
                    pagination={{
                        onChange: cancel,
                    }}
                    />
                )}
            </Form>
            <Create 
            isModalOpen={isModalOpen} 
            setIsModalOpen={setIsModalOpen}
            update={getCouriers}
            />
        </div>
    );
}